import React, { useEffect } from 'react';
import { observer } from 'mobx-react-lite';
import { useContributionFormPageStore } from 'store/pages/enrollment/contribution-form/contributionFormPageStore';
import { CARD_DATA } from 'global/checklists-helpers/ChecklistHelper';
import ProposalStatusLayout from 'components/common/proposal/ProposalStatusLayout';
import EnrollmentSafeguardPageHeader from 'components/common/enrollment/SafeguardPageHeader';
import { SpinnerPlaceholder } from 'components/common/SpinnerPlaceholder';
import { DynamicForm } from '@insurancemenu/imenu-components-lib';
import { PageWrapperStyled } from '../../../globalStyles';

// TESTING_POLICY: CYPRESS_ONLY

const Form = observer((): React.ReactNode => {
  const { dynamicFormDelegate, isInitialDataLoading, safeguardDelegate, enrollmentPeriodModule, getInitialData } =
    useContributionFormPageStore();

  useEffect(() => {
    void getInitialData();
  }, []);

  return (
    <>
      {isInitialDataLoading || !dynamicFormDelegate ? (
        <SpinnerPlaceholder height="40rem" />
      ) : (
        <DynamicForm
          formDelegate={dynamicFormDelegate}
          isEditable={!enrollmentPeriodModule.isEnrollmentImmutable}
          onBack={safeguardDelegate.onBackButtonStrategy}
          backButtonText={safeguardDelegate.isStepCompleted ? 'Exit' : 'Save & Exit'}
          completeButtonText={safeguardDelegate.isStepCompleted ? 'Update Contribution' : 'Complete Contribution'}
        />
      )}
    </>
  );
});

const PageContent: React.FC = observer(() => {
  const { safeguardDelegate } = useContributionFormPageStore();

  return (
    <ProposalStatusLayout>
      <PageWrapperStyled>
        <EnrollmentSafeguardPageHeader
          title={CARD_DATA.EMPLOYER_CONTRIBUTION.title}
          subtitle={CARD_DATA.EMPLOYER_CONTRIBUTION.text}
          enrollmentHeaderSafeguardDelegate={safeguardDelegate}
        />
        <Form />
      </PageWrapperStyled>
    </ProposalStatusLayout>
  );
});

export default PageContent;
